"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (d) {
  return d;
};
//# sourceMappingURL=identity.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-stockcharts/lib/utils/identity.js
// module id = 96
// module chunks = 0